// extracted by mini-css-extract-plugin
module.exports = {"outdoor-recreation-H1":"H1_outdoor-recreation-H1___fkCr"};